module.exports = __webpack_public_path__ + "static/img/1.6493296e.png";